angular.module('storefrontApp')
    .directive('restrictInput', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link(scope, element, attr, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    const options = scope.$eval(attr.restrictInput);

                    if (!options.regex && options.type) {
                        switch (options.type) {
                            case 'digitsOnly':
                                options.regex = '^[0-9]*$';
                                break;
                            case 'lettersOnly':
                                options.regex = '^[a-zA-Zа-яА-ЯёЁ -]*$';
                                break;
                            case 'lowercaseLettersOnly':
                                options.regex = '^[a-zа-яё -]*$';
                                break;
                            case 'uppercaseLettersOnly':
                                options.regex = '^[A-ZА-ЯЁ -]*$';
                                break;
                            case 'lettersAndDigitsOnly':
                                options.regex = '^[a-zA-Zа-яА-ЯёЁ0-9 -]*$';
                                break;
                            case 'validPhoneCharsOnly':
                                options.regex = '^[0-9 ()/-]*$';
                                break;
                            default:
                                options.regex = '';
                        }
                    }

                    const reg = new RegExp(options.regex);

                    if (reg.test(viewValue)) { // if valid view value, return it
                        return viewValue;
                    }

                    // if not valid view value, use the model value (or empty string if that's also invalid)
                    const overrideValue = (reg.test(ctrl.$modelValue) ? ctrl.$modelValue : '');

                    element.val(overrideValue);

                    return overrideValue;
                });
            },
        };
    });
